<template lang="pug">
    .container(
        ref='container'
        )
        .animated-scroll(
            ref='animatedScroll',
            )
            .masked-text(v-if='content')
                .content(ref='content' :class='theme')
                    .section-block(
                        v-for='block in content',
                        :class='[block.position, block.modifier]'
                        )

                        .texts(v-if='block.type === "text"')

                            .texts__wrap(v-if='Array.isArray(block.textblocks)' v-html='block.textblocks.join("")')

                            .texts__side-illustration(v-if='block.quote || block.counter || block.animation || block.imageblock')
                                .quote(
                                    v-if='block.quote'
                                    )
                                    .quote__content(v-html='block.quote')

                .masked-text__mask-wrp
                    .masked-text__mask
                        .mask(ref='mask')
                            .bg-holder.right(:class='bgTheme')
                            img(:src='require(`../../assets/img/text-appearing/bullet-crossing.svg`)')
                            .bullets
                                .bullet
                                    img.bullet__img(:src='require(`../../assets/img/text-appearing/bullet.svg`)')
                                .bullet
                                    img.bullet__img(:src='require(`../../assets/img/text-appearing/bullet.svg`)')
                                .bullet
                                    img.bullet__img(:src='require(`../../assets/img/text-appearing/bullet.svg`)')
                                .bullet
                                    img.bullet__img(:src='require(`../../assets/img/text-appearing/bullet.svg`)')

</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/animatedScreen';
export default {
    name: 'AnimatedScroll',
    props: {
        content: {
            type: Array
        },
        settings: Object,
        name: String,
        theme: String,
        bgTheme: String,
        isActive: Boolean
    },
    mixins: [mixinAnimation],
    data() {
        return {
            bScrollInst: null,
            timeline: null,
            isInited: false,
            innerBlockPosition: 'top',
            isControlScroll: true
        };
    },
    methods: {
        createAnimation() {
            if (
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent) ||
                document.documentElement.clientWidth < 768
            ) {
                this.$refs.container.classList.add('container_off');
                return;
            }
            this.createTimeline();
            this.createScroll();
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            let bullets = this.$refs.container.querySelectorAll('.bullet');
            this.timeline.fromTo(bullets, {x: 0}, {x: 'random(1000, 3000)%'}, 0).fromTo(this.$refs.mask, {x: 0}, {x: '100%'}, 0);
            this.timeline.progress(0.0001);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';

.container {
    height: 200vh;
    &_off {
        height: fit-content;
        .animated-scroll {
            position: static !important;
            .masked-text__mask-wrp {
                display: none;
            }
        }
    }
    position: relative;
    overflow: hidden;
}

.animated-scroll {
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    min-height: 100vh;
    width: 100%;
}

.masked-text {
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 0;
    min-height: 100vh;
    @media (--viewport-tablet) {
        padding: 28px 0 0;
        align-items: flex-start;
    }
    .section-block {
        &:last-child {
            padding: 0;
        }
    }

    .content {
        &.black {
            color: var(--color-white);
            background-color: var(--color-black);
        }
        &.white {
            color: var(--color-black);
            background-color: var(--color-white);
        }
        &.color {
            background-color: var(--theme);
        }
    }
    .masked-text__mask-wrp {
        @media (--viewport-tablet) {
            display: none;
        }
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
    }
    &__mask {
        position: absolute;
        top: 0;
        right: 0;
        //transform: translate(-50%, -50%);
        width: fit-content;
        height: fit-content;
        pointer-events: none;
        z-index: 1;
    }
}

.mask {
    padding: 0 200vw 0 50vw;
    height: 100vh;
    width: max-content;
    //transform: translate(calc(150% * var(--translate)));
    img {
        width: auto;
        height: 100%;
        display: block;
    }
}
.bg-holder {
    position: absolute;
    &.color {
        background-color: var(--color-white);
    }
    &.black {
        background-color: var(--color-black);
    }
    &.color {
        background-color: var(--theme);
    }
    &.right {
        right: 0;
        top: 0;
        height: calc(100% + 1px);
        width: calc(200vw + 1px);
    }
}

.bullets {
    position: absolute;
    top: 43%;
    left: 40%;
    transform: translateY(-50%);
}

.bullet {
    position: absolute;
    height: 6vh;
    width: auto;
    &:nth-child(1) {
        //transform: translate(calc(3500% * var(--translate)));
        top: -2vh;
    }
    &:nth-child(2) {
        top: 7vh;
        left: 4vw;
        //transform: translate(calc(3000% * var(--translate)));
    }
    &:nth-child(3) {
        left: 18vw;
        top: 2vh;
        //transform: translate(calc(1000% * var(--translate)));
    }
    &:nth-child(4) {
        left: 27vw;
        top: 7vh;
        //transform: translate(calc(4000% * var(--translate)));
    }
    img {
        max-width: none;
    }
}
</style>
